import React, { useMemo } from 'react';
import MapUnavailable from './MapUnavailable';
import { isEmbeddedFrame } from '../../../Utils/isEmbeddedFrame';

/**
 * Aviso chico de los share sin WebGL (arriba de la lista o la ficha a todo el ancho).
 * Embebido en la landing (iframe, alto ~360–640px): versión compacta, una línea,
 * con «Abrir en Terrio» en pestaña nueva hacia la URL actual.
 *
 * @param {{ reason?: string|null }} props
 */
export default function ShareMapUnavailableNotice({ reason = null }) {
  const embedded = useMemo(() => isEmbeddedFrame(), []);
  const href = embedded && typeof window !== 'undefined' ? window.location.href : null;
  return (
    <MapUnavailable
      variant="inline"
      reason={reason}
      compact={embedded}
      openInTerrioHref={href}
    />
  );
}
